import styles from './Staff.module.css';

import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import React, {useEffect, useState} from 'react';

import ScrittaEBLCraft from '@/commons/resources/images/eblcraft/scrittaEBLCraft.png'
import StaffImage from '@/commons/resources/images/eblcraft/staffImage.png';
import ApiInterface from "@/commons/api/ApiInterface";


const StaffPage = () => {
    let [groups, setGroups] = useState([]);
    const getGroups = () => {
        ApiInterface.getGroups().then(async (res) => {
            if (res.status !== 200) {
                return;
            }
            let result = await res.json();
            let groups = result["groups"];
            setGroups(groups);
        })
    }


    getGroups();

    return (
        <>
            <div className={styles.body}>
                <Header/>

                <div className={styles.preContent}>
                    <img src={StaffImage} alt={"foto dello staff, raduno staff 2024"}/>
                    <span className={styles.title}>lo staff</span>
                </div>
                <div className={styles.content}>
                    <img className={styles.scritta} src={ScrittaEBLCraft} alt="ScrittaEBLCraft"/>
                    <span className={styles.title}>conosci lo staff</span>
                    <span className={styles.text}>Dietro ogni blocco posato, ogni evento organizzato e ogni
                        aggiornamento pubblicato, c’è un gruppo di persone che lavora ogni giorno per rendere EBLCraft
                        un ambiente unico, stabile e divertente per tutti.<br/>
                        Lo staff di EBLCraft non è composto da semplici moderatori o tecnici: è un team affiatato di
                        appassionati che conosce a fondo il gioco e la community, e che mette impegno e passione nel
                        mantenere vivo il server.<br/>
                        Ogni modalità, ogni funzione e ogni miglioramento nasce da ore di lavoro, confronto e test.
                        Dalla gestione dei plugin alla moderazione della chat, dalla costruzione delle mappe ai sistemi
                        di gioco personalizzati, lo staff si occupa di tutto ciò che serve per garantire un’esperienza
                        fluida, equa e coinvolgente.<br/>
                        Che tu sia un nuovo arrivato o un veterano, puoi contare su di noi. Il nostro obiettivo è
                        semplice: offrirti un mondo in cui tornare ogni volta con il sorriso.
                    </span>
                    <div className={styles.stafferZone}>

                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
};

export default StaffPage;
